import { RepositionEntityType } from '../types/helper';
import baseApi from './base';
import { ElementTag, FramesTag } from './tags';

interface RepositionElementQueryType {
  frameId: string;
  elementPositions: RepositionEntityType[];
}

export interface ElementCreateResponse {
  id: string;
  name: string;
}

export interface ElementCreatePayload {
  id?: string;
  frameId: string;
  name: string;
  content: string;
  elementMetadata: {
    elementType: number;
    type?: number;
    position?: number;
    width?: number;
    height?: number;
  };
}

const elementsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createElement: build.mutation<
      ElementCreateResponse,
      Partial<ElementCreatePayload>
    >({
      query(element) {
        const type = element.elementMetadata?.elementType
          ? element.elementMetadata?.elementType
          : 1;

        const finalElement = {
          ...element,
          ...{
            elementMetadata: {
              ...element.elementMetadata,
              ...{
                type: type * 1, // temporary solution to fix that is passed as string in payload.
              },
            },
          },
        };
        delete finalElement.frameId;
        delete finalElement.elementMetadata.elementType;
        if (element.id) {
          return {
            url: `elements/${element.id}`,
            method: 'PUT',
            body: finalElement,
            responseType: 'json',
          };
        }

        return {
          url: `elements/${element.frameId}`,
          method: 'POST',
          body: finalElement,
          responseType: 'json',
        };
      },
      invalidatesTags: [{ type: ElementTag }, { type: FramesTag }],
    }),
    deleteElement: build.mutation<{ success: boolean; id: number }, string>({
      query(id) {
        return {
          url: `elements/${id}`,
          method: 'DELETE',
        };
      },
      // Invalidates all queries that subscribe to this Post `id` only.
      invalidatesTags: (result, error, id) => [{ type: ElementTag, id }, { type: FramesTag }],
    }),
    repositionElement: build.mutation<any, RepositionElementQueryType>({
      query(payload) {
        return {
          url: `frames/${payload.frameId}/elements/position`,
          method: 'POST',
          body: payload.elementPositions,
        };
      },
      invalidatesTags: [ElementTag, FramesTag],
    }),
  }),
});

export const {
  useCreateElementMutation,
  useDeleteElementMutation,
  useRepositionElementMutation,
} = elementsApi;

export default elementsApi;
